import gql from 'graphql-tag';

const externalCancelledPurchasesQuery = gql`
  query ExternalCancelledPurchases(
    $page: Int
    $limit: Int
    $categoryCode: String
    $vin: String
    $dealer: String
  ) {
    externalCancelledPurchases(
      page: $page
      limit: $limit
      categoryCode: $categoryCode
      vin: $vin
      dealer: $dealer
    ) {
      total
      items {
        externalId
        status
        guaranteeStatus
        buyerEmail
        auctionAccessNo
        dealerNo
        vin
        universalNo
        guaranteeDaysSelected
        guaranteeMilesSelected
        guaranteeIfBid
        guaranteeSellerPaid
        automaticPurchase
        salePrice
        guaranteePrice
        inspectionPrice
        cancellingUserName
        cancellationDate
        cancellationReason
        cancelledPurchaseId
      }
    }
  }
`;

export default externalCancelledPurchasesQuery;
